import { LuDot } from "react-icons/lu";

const NavBar = ({ title }) => {
  
  const now = new Date();
  const istTime = now.toLocaleTimeString("en-IN", {
    timeZone: "Asia/Kolkata",
    hour: "2-digit",
    minute: "2-digit",
  });

  const istDate = now.toLocaleDateString("en-IN", {
    timeZone: "Asia/Kolkata",
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });

  return (
    <div className="bg-white border-gray-700 border-b px-[0.5vw]">
      <ul className="bg-white pr-[3vw] h-[64px] flex flex-row justify-between items-center">
        <li className="flex items-center justify-center list-none text-[rgba(48,48,48,0.863)]">
          <h2 className="font-bold ml-1">{title}</h2>
        </li>


        <li className="flex items-center justify-center list-none text-[rgba(48,48,48,0.863)]">
          <ul className="flex flex-row justify-center items-center gap-4">
            <li>
              <p className="text-[16px] flex flex-row justify-center items-center font-medium text-black">
                {istDate}
              </p>
            </li>
            <li>
              <p className="text-[16px] flex flex-row justify-center items-center font-medium text-black">
                {istTime}
                <span className="text-green-600 text-4xl">
                  <LuDot />
                </span>
              </p>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  );
};

export default NavBar;
